
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AnalysisRequestSubject } from '@/modules/analysis/models/analysisRequest';
import { Location } from '@/modules/nomenclature/models/location';
import { BudgetLine } from '@/modules/nomenclature/models/budgetLine';
import * as LocationService from '@/modules/nomenclature/services/locationService';
import * as ProjectService from '@/modules/nomenclature/services/projectService';

@Component({
  components: {}
})
export default class AboutSubject extends Vue {
  @Prop()
  protected subject?: AnalysisRequestSubject;
  protected location: Location | null = null;
  protected budgetLine: BudgetLine | null = null;

  @Watch('subject', { immediate: true })
  protected onSubjectChange(): void {
    if (this.subject?.locationId) {
      LocationService.fetchById(this.subject.locationId).then((res) => (this.location = res.data));
    }
    if (this.subject?.budgetLineId) {
      ProjectService.fetchBudgetLineById(this.subject.budgetLineId).then((res) => (this.budgetLine = res.data));
    }
  }
}
